import TopHeader from "./TopHeader";
import SubHeader from "./SubHeader";
import StatGptNavbar from "./StatGptNavbar";
import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const ParentHeader = () => {
  const { pathname } = useLocation();
  const isMyLeaguesInner = /^\/my-leagues\/[^/]+/.test(pathname);
  const hideTopHeader =
    pathname === "/leagues-home" ||
    isMyLeaguesInner ||
    pathname.startsWith("/tournamentDetails/") ||
    pathname.startsWith("/tournaments/tournaments-details") ||
    pathname.startsWith("/tournaments/team-info") ||
    pathname.startsWith("/tournaments/create-tournament") ||
    pathname.startsWith("/tournaments/create-division") ||
    pathname.startsWith("/tournaments/schedule-match") ||
    pathname.startsWith("/ground-details/") ||
    pathname.startsWith("/create-waiver");

  useEffect(() => {
    document.body.classList.toggle("route-hide-top-header", hideTopHeader);

    return () => {
      document.body.classList.remove("route-hide-top-header");
    };
  }, [hideTopHeader]);

  // TopHeader's rendered height isn't a fixed constant (it grows/shrinks with its
  // content, e.g. the logo), but SubHeader is a separately `position: fixed` element
  // stacked right below it — so SubHeader's `top` offset has to track TopHeader's
  // *actual* height or the two bars overlap. Measuring it here (instead of hardcoding
  // it again in CSS) keeps them in sync even if TopHeader's content changes later.
  useLayoutEffect(() => {
    const root = document.documentElement;
    if (hideTopHeader) {
      root.style.setProperty("--top-header-height", "0px");
      return;
    }
    const el = document.querySelector<HTMLElement>(".top-header");
    if (!el) return;
    const setHeight = () => {
      root.style.setProperty("--top-header-height", `${el.getBoundingClientRect().height}px`);
    };
    setHeight();
    const observer = new ResizeObserver(setHeight);
    observer.observe(el);
    return () => observer.disconnect();
  }, [hideTopHeader]);

  const hideSubHeader =
    pathname === "/" ||
    pathname === "/home" ||
    pathname.startsWith("/my-team") ||
    (pathname.startsWith("/my-leagues") && !isMyLeaguesInner) ||
    pathname.startsWith("/create-league") ||
    pathname.startsWith("/features/league-manager") ||
    pathname.startsWith("/features/live-streaming") ||
    pathname.startsWith("/coming-soon") ||
    pathname.startsWith("/tournaments/player-profile") ||
    pathname.startsWith("/matches-details") ||
    pathname.startsWith("/stat-gpt") ||
    pathname.startsWith("/pricing") ||
    pathname.startsWith("/about") ||
    pathname.startsWith("/careers") ||
    pathname.startsWith("/privacy-policy") ||
    pathname.startsWith("/terms-of-service") ||
    pathname.startsWith("/features/ai-highlights") ||
    pathname.startsWith("/features/scoring") ||
    pathname.startsWith("/profile") || 
    pathname.startsWith("/streamer-dashboard");

  const showStatGptNavbar = pathname.startsWith("/stat-gpt");

  return (
    <>
      {!hideTopHeader && <TopHeader />}
      {!hideSubHeader && <SubHeader />}
      {showStatGptNavbar && <StatGptNavbar />}
    </>
  );
};
export default ParentHeader;
